import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useNotify } from "../../../context/NotificationContext";
import { useCommon } from "../../../context/CommonContext";
import spotlightService from "../../../services/spotlightService";
import SpotlightForm from "./SpotlightForm";

const AddSpotlight = () => {
  const navigate = useNavigate();
  const notify = useNotify();
  const { setPageTitle } = useCommon();

  useEffect(() => {
    setPageTitle("Add Spotlight");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (payload) => {
    try {
      const response = await spotlightService.createSpotlight(payload);

      if (response?.data?.status) {
        notify.success({
          message: response.data.message || "Spotlight created successfully",
        });
        navigate("/spotlights");
      } else {
        notify.error({
          message: response?.data?.message || "Failed to create spotlight",
        });
      }
    } catch (error) {
      console.error("Error creating spotlight:", error);
      notify.error({
        message: error?.data?.message || "Error creating spotlight",
      });
    }
  };

  return <SpotlightForm mode="add" onSubmit={handleSubmit} />;
};

export default AddSpotlight;
